import React from 'react';
import PropTypes from 'prop-types';
import { Trans, useTranslation } from 'react-i18next';
import clsx from 'clsx';
import Typography from '@material-ui/core/Typography';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import Button from '@material-ui/core/Button';

// CONSTANTS
import { LOCATIONS_PARTNER_TV_PAGE } from '@/constants/locations';

// utility
import { externalLink } from '@/utility/analytics';

// STYLES
import { Container } from './styles';

const AcpQualification = ({ partner }) => {
  const [t] = useTranslation();
  const downXs = useMediaQuery(({ breakpoints }) => breakpoints.down('xs'));
  const partnerSettings = partner.settings || {};
  const textOverwrites = partner?.text_overwrites || {};

  if (!partnerSettings.show_acp_qualification) return null;

  const handleExternalLink = url => {
    const properties = {
      location: LOCATIONS_PARTNER_TV_PAGE,
      href: url,
      partner: partner.partner_slug,
      partner_id: partner.partner_id,
    };

    externalLink(properties);
  };

  return (
    <Container className="section section--dark acp-qualification">
      <div className="page-content">
        <Typography
          className="text-bold m-b-25"
          component="h2"
          variant={downXs ? 'h4' : 'h2'}
          align="center"
        >
          {t('partnerTV.acpQualification.title')}
        </Typography>
        <ul className="steps">
          <li className="steps__item">
            <span className="steps__number">1</span>
            <Typography className="p3 steps__text">
              <Trans i18nKey="partnerTV.acpQualification.step1" />
            </Typography>
          </li>
          <li className="steps__item">
            <span className="steps__number">2</span>
            <Typography className="p3 steps__text">
              <Trans i18nKey="partnerTV.acpQualification.step2" />
            </Typography>
          </li>
          <li className="steps__item">
            <span className="steps__number">3</span>
            <Typography className="p3 steps__text">
              <Trans i18nKey="partnerTV.acpQualification.step3" />
            </Typography>
          </li>
        </ul>
        <div className="text-center">
          {!!textOverwrites.acp_qualification_url && (
            <Button
              href={textOverwrites.acp_qualification_url}
              onClick={() => handleExternalLink(textOverwrites.acp_qualification_url)}
              color="secondary"
              location={LOCATIONS_PARTNER_TV_PAGE}
              size={clsx(downXs ? 'medium' : 'large')}
            >
              {t('partnerTV.acpQualification.button')}
            </Button>
          )}
        </div>
      </div>
    </Container>
  );
};

AcpQualification.propTypes = {
  partner: PropTypes.object.isRequired,
};

export default React.memo(AcpQualification);
